import { motion } from "framer-motion";
import { useState } from "react";
import emailjs from "emailjs-com";
import Section from "./hoc/Section";

const fadeLeft = {
  hidden: { opacity: 0, x: -120 },
  show: { opacity: 1, x: 0, transition: { duration: 1.2, ease: "easeOut" } },
};

const fadeRight = {
  hidden: { opacity: 0, x: 120 },
  show: { opacity: 1, x: 0, transition: { duration: 1.2, ease: "easeOut" } },
};

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        "service_hwmfhhh", // Replace with your EmailJS Service ID
        "template_9my7moc", // Replace with your EmailJS Template ID
        {
          name: form.name,
    project_name: form.projectName,
    email: form.email,
    description: form.description,
    start_date: form.startDate,
    budget: form.budget,
    timeline: form.timeline,
        },
        "_aKGYJXoIucqqeWEf" // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          setLoading(false);
          setStatus("Message sent successfully! ✅");
          setForm({
            name: "",
            projectName: "",
            email: "",
            description: "",
            startDate: "",
            budget: "",
            timeline: "3 months",
          });
        },
        (error) => {
          console.error(error);
          setLoading(false);
          setStatus("Something went wrong. Please try again. ❌");
        }
      );
  };

  return (
    <section className="w-full min-h-screen text-white flex flex-col items-center py-20 overflow-hidden">
      {/* Heading */}
      <motion.h1
        variants={fadeLeft}
        initial="hidden"
        whileInView="show"
        viewport={{ amount: 0.3 }}
        className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center"
      >
        We Are <span className="font-poppins">Here&nbsp;To&nbsp;Help</span>
      </motion.h1>

      {/* Contact Box */}
      <motion.div
        variants={fadeRight}
        initial="hidden"
        whileInView="show"
        viewport={{ amount: 0.3 }}
        className="gradient-border mt-12 w-[90%] max-w-[1100px] rounded-lg"
      >
        <div className="gradient-border-inner background-color2 p-6 md:p-10 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Image */}
          <motion.div
  variants={fadeLeft}
  initial="hidden"
  whileInView="show"
  viewport={{ amount: 0.3 }}
  className="w-full"
>
  <img
    src="https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fee8_contact-hero-image.webp"
    alt="contact"
    className="rounded-md object-cover w-full md:h-[740px] hidden sm:block"
  />
</motion.div>


          {/* Right Form */}
          <motion.div
            variants={fadeRight}
            initial="hidden"
            whileInView="show"
            viewport={{ amount: 0.3 }}
          >
            <h2 className="text-3xl sm:text-4xl font-semibold mb-6">
              Contact&nbsp;Us
            </h2>
<form
              onSubmit={handleSubmit}
              className="space-y-2 font-playfair text-sm sm:text-base"
            >
              {/* Name */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400"
                  required
                />
              </div>

              {/* Project Name */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Project Name</label>
                <input
                  type="text"
                  name="projectName"
                  value={form.projectName}
                  onChange={handleChange}
                  placeholder="Project Name"
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400"
                  required
                />
              </div>

              {/* Project Description */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Project Description</label>
                <textarea
                  name="description"
                  rows={3}
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Describe your project"
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400 resize-none"
                  required
                />
              </div>

            {/* Start Date */}
<div>
  <label className="block text-xs sm:text-sm mb-1">Start Date</label>
  <input
  type="date"
  name="startDate"
  value={form.startDate}
  onChange={handleChange}
  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-3 sm:px-4 sm:py-3 text-white placeholder:text-gray-400 appearance-none leading-none"
  required
/>

  <style jsx>{`
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);  /* Makes icon white */
    cursor: pointer;
  }
  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-clear-button {
    display: none;
  }
`}</style>

</div>


              {/* Budget */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Budget</label>
                <input
                  type="number"
                  name="budget"
                  value={form.budget}
                  onChange={handleChange}
                  placeholder="$"
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400"
                  required
                />
              </div>

              {/* Project Timeline */}
              <div>
                <label className="block text-xs sm:text-sm mb-1">Project Timeline</label>
                <select
                  name="timeline"
                  value={form.timeline}
                  onChange={handleChange}
                  className="w-full bg-transparent border border-[#722bff] rounded px-3 py-2 sm:px-4 sm:py-3 text-white placeholder:text-gray-400"
                >
                  <option value="3 months">3 Months</option>
                  <option value="6 months">6 Months</option>
                  <option value="1 year">1 Year</option>
                </select>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-2 sm:py-3 mt-2 rounded-lg bg-gradient-to-r from-[#722bff] to-[#cc97f4] font-semibold hover:opacity-90 transition"
              >
                {loading ? "Sending..." : "Submit"}
              </button>

              {/* Status Message */}
              {status && (
                <p className="mt-2 text-center text-sm text-gray-300">{status}</p>
              )}
            </form>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};
export default Section(Contact, "contact");